import jsPDF from "jspdf";
import QRCode from "qrcode";

export const generateQrcodePDF = async (qrCodeValue, name, onError = null) => {
  if (!qrCodeValue) {
    if (onError) {
      onError("No QR code to print");
    } else {
      console.error("No QR code to print");
    }
    return;
  }

  try {
    const qrCodeDataUrl = await QRCode.toDataURL(qrCodeValue, {
      errorCorrectionLevel: "H",
      width: 200,
      margin: 2,
    });

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    // Title
    pdf.setFontSize(20);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(40, 62, 80);
    pdf.text('Checkpoint QR Code', 105, 20, { align: 'center' });

    // Checkpoint name
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor(70, 100, 130);
    pdf.text(name || 'Checkpoint', 105, 30, { align: 'center' });

    // QR Code border
    pdf.setDrawColor(200, 200, 200);
    pdf.setFillColor(250, 250, 250);
    pdf.roundedRect(75, 45, 60, 80, 3, 3, 'FD');

    // QR Code image
    pdf.addImage(qrCodeDataUrl, "PNG", 85, 50, 40, 40);

    // QR Code value
    pdf.setFontSize(10);
    pdf.setTextColor(100, 100, 100);
    const splitText = pdf.splitTextToSize(qrCodeValue, 50);
    pdf.text(splitText, 105, 95, { align: 'center' });

    // Checkpoint label
    pdf.setFontSize(12);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(40, 62, 80);
    const checkpointName = name || 'Checkpoint';
    pdf.text(`Checkpoint: ${checkpointName}`, 105, 110, { align: 'center' });

    // Footer
    pdf.setFontSize(8);
    pdf.setTextColor(150, 150, 150);
    const date = new Date().toLocaleDateString();
    pdf.text(`Generated on: ${date}`, 105, 140, { align: 'center' });
    pdf.text('Maximal Security Services', 105, 145, { align: 'center' });

    // Save PDF
    const fileName = `QRCode_${checkpointName.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`;
    pdf.save(fileName);
    
    return true; // Success
  } catch (error) {
    console.error("Failed to generate QR code PDF:", error);
    if (onError) {
      onError("Failed to generate QR code PDF");
    }
    return false; // Failure
  }
};
